




























































import { Component, Vue, Prop, PropSync } from 'vue-property-decorator'
import { Classification } from '@/domain/Classification'
import { Department } from '@/domain/Department'
import { ReportType } from '@/domain/ReportType'
import DepartmentsService from '@/service/DepartmentsService'
import ReportTypesService from '@/service/ReportTypesService'

@Component
export default class ClassificationDialogComponent extends Vue {
  departmentsService = DepartmentsService.instance
  reportTypesService = ReportTypesService.instance

  @PropSync("value", { type: Boolean , default: false, required: false })
  dialog!: boolean

  @PropSync("default", { type: Classification, default: () => new Classification(), required: true })
  dto!: Classification

  @Prop({ default: true })
  isNew!: boolean

  /** バリデーション */
  invalid = false

  departments: Department[] = []
  reportTypes: ReportType[] = []

  mounted() {
    /* 部門 */
    this.departmentsService.findAll()
      .then(x => this.departments = x)
    /* 報告書タイプ */
    this.reportTypesService.findAll()
      .then(x => this.reportTypes = x)
  }

  /**
   * 初期化
   */
  reset() {
    this.dto = new Classification()
  }

  /**
   * キャンセルボタンのクリック
   */  
  onCancel() {
    this.dialog = false
    this.reset()
  }

  /**
   * 確定のクリック
   */  
  onSubmit() {
    this.dialog = false
    this.$emit("input", this.dto)
    this.reset()
  }

}
